export const LIST_COLUMNS = [
  { title: '工厂', dataIndex: 'organizationName', width: 140, align: 'center' },
  { title: '叫料单号', dataIndex: 'callDocNumber', width: 140, align: 'center' },
  { title: '行号', dataIndex: 'lineNumber', width: 75, align: 'center' },
  { title: '工单号', dataIndex: 'wipEntityName', width: 120, align: 'center' },
  { title: '工单状态', dataIndex: 'wipStatusName', width: 90, align: 'center' },
  { title: '工单创建时间', dataIndex: 'createTime', width: 140, align: 'center' },
  { title: '一次达交考核时间', dataIndex: 'deliveryDate', width: 140, align: 'center' },
  { title: '计划完成时间', dataIndex: 'scheduledCompletionDate', width: 140, align: 'center' },
  { title: '要求到料时间', dataIndex: 'requiredDeliveryDate', width: 140, align: 'center' },
  { title: '物料编码', dataIndex: 'completedItemCode', width: 120, align: 'center' },
  { title: '物料名称', dataIndex: 'completedItemName', width: 120, align: 'center' },
  { title: '规格描述', dataIndex: 'completedSpecification', width: 160, align: 'center', ellipsis: true },
  { title: '工单套数', dataIndex: 'planQuantity', width: 90, align: 'center' },
  { title: '状态', dataIndex: 'statusName', width: 105, scopedSlots: { customRender: 'statusName' }, align: 'center' },
  { title: '材料模式', dataIndex: 'materialModelName', width: 75, align: 'center' },
  { title: '原材料-物料编码', dataIndex: 'rawMaterialCode', width: 100, align: 'center' },
  { title: '原材料-物料名称', dataIndex: 'rawMaterialName', width: 140, align: 'center' },
  { title: '原材料-规格描述', dataIndex: 'rawMaterialSpecification', width: 180, align: 'center', ellipsis: true },
  { title: '单位', dataIndex: 'uom', width: 70, align: 'center' },
  { title: 'BOM需求数量', dataIndex: 'bomDemandQty', width: 75, align: 'center' },
  { title: '已叫料量', dataIndex: 'callQty', width: 70, align: 'center' },
  { title: '未叫料量', dataIndex: 'unCallQty', width: 70, align: 'center' },
  { title: '工厂库存', dataIndex: 'factoryTempQty', width: 75, align: 'center' },
  { title: '计划送货时间', dataIndex: 'planDeliveryTime', width: 140, align: 'center' },
  { title: '材料商', dataIndex: 'materialSupplier', scopedSlots: { customRender: 'materialSupplier' }, width: 160, align: 'center' },
  { title: '收货子库', dataIndex: 'subinventory', width: 100, align: 'center' },
  { title: '驳回原因', dataIndex: 'rejectedReason', width: 120, align: 'center' },
  { title: '材料一级分类', dataIndex: 'name1', width: 95, align: 'center' },
  {
    title: '操作',
    width: 90,
    align: 'center',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    stickyFixed: 'right'
  }
]

export const CREATE_COLUMNS = [
  { title: '工厂', dataIndex: 'organizationName', ellipsis: true, width: 120, align: 'center' },
  // { title: '工单号', dataIndex: 'wipEntityName', ellipsis: true, width: 140, align: 'center' },
  { title: '原材料编码', dataIndex: 'rawMaterialCode', width: 120, ellipsis: true, align: 'center' },
  { title: '原材料名称', dataIndex: 'rawMaterialName', width: 120, align: 'center', ellipsis: true },
  { title: '单位', dataIndex: 'uom', width: 70, align: 'center' },
  { title: '未叫料', dataIndex: 'unCallQty', width: 85, align: 'center' },
  { title: '可叫料数', dataIndex: 'canCallQty', width: 85, align: 'center' },
  {
    // title: '叫料量',
    dataIndex: 'callQty',
    width: 100,
    align: 'center',
    scopedSlots: { customRender: 'callQty', title: "callQtyTitle" },
    type: "inputNumber"
  },
  {
    // title: '材料商',
    dataIndex: 'materialSupplier',
    // ellipsis: true,
    width: 190,
    scopedSlots: { customRender: 'materialSupplier', title: "materialSupplierTitle" },
    align: 'center'
  },
  {
    // title: '要求送达时间',
    dataIndex: 'planDeliveryTime',
    width: 120,
    scopedSlots: { customRender: 'planDeliveryTime', title: "planDeliveryTimeTitle" },
    align: 'center'
  },
  {
    title: '备注',
    scopedSlots: { customRender: 'remark' },
    dataIndex: 'remark',
    width: 150,
    align: 'center'
  },
  {
    title: '操作',
    width: 100,
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    align: 'center',
    fixed: 'right'
  }
]
